import React, { useState } from 'react'
import {
  Accordion,
  Badge,
  Button,
  Card,
  Col,
  Offcanvas,
  Row,
  Table
} from 'react-bootstrap'
import moment from 'moment'
import axiosProvider from '../../../lib/AxiosProvider'
import { _productImg_ } from '../../../lib/ImagePath'
import CustomToast from '../../../components/Toast/CustomToast'
import Swal from 'sweetalert2'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import ConfirmReturnRequest from './ConfirmReturnRequest'
import { _orderStatus_ } from '../../../lib/AllStaticVariables'
import { encodedSearchText, showToast } from '../../../lib/AllGlobalFunction'

function ReturnOrderDetail({
  setOrderDetailModalShow,
  orderDetailModalShow,
  setLoading,
  getOrderItems,
  filterDetails
}) {
  const [modalShow, setModalShow] = useState({ show: false, data: null })
  const { userInfo } = useSelector((state) => state?.user)
  const location = useLocation()
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })

  return (
    <>
      <Offcanvas
        className='pv-offcanvas'
        placement='end'
        show={orderDetailModalShow.show}
        backdrop='static'
        onHide={() => {
          setOrderDetailModalShow({
            show: !orderDetailModalShow?.show,
            data: null
          })
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className='bold'>Order Detail</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card>
            <Card.Body>
              <Card.Title className='cfz-18'>
                Order Number:{' '}
                <span className='fw-bolder'>
                  {' '}
                  {orderDetailModalShow?.data?.orderNo}
                </span>
              </Card.Title>
              <div className='d-flex justify-content-between align-items-center'>
                <Card.Text className='mb-0'>
                  Order Date:{' '}
                  <b>
                    {moment(orderDetailModalShow?.data?.orderDate).format(
                      'DD/MM/YYYY'
                    )}
                  </b>
                </Card.Text>
              </div>
            </Card.Body>
          </Card>

          {/* <Formik initialValues={initialValues?.pack}>
            {({ values, setFieldValue }) => (
              <Form> */}
          <Row className='w-100 m-auto align-items-start mt-4'>
            <Col md={8}>
              <Accordion>
                <Accordion.Item
                  eventKey={orderDetailModalShow?.data?.orderItems?.sizeID}
                >
                  <Accordion.Header>
                    <div className='p-1 rounded pv-model-bg'>
                      <span className='cfz-14 mx-2'>
                        Seller name:{' '}
                        <b>
                          {' '}
                          {orderDetailModalShow?.data?.orderItems?.sellerName}
                        </b>
                      </span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className='border mt-4 p-3 position-relative'>
                      <div className='pv-order-status'>
                        <Badge
                          className={
                            orderDetailModalShow?.data?.orderItems?.status ===
                            _orderStatus_.placed
                              ? 'badge bg-info'
                              : orderDetailModalShow?.data?.orderItems
                                  ?.status === _orderStatus_.delivered
                              ? 'badge bg-success'
                              : orderDetailModalShow?.data?.orderItems
                                  ?.status === _orderStatus_.cancelled ||
                                orderDetailModalShow?.data?.orderItems
                                  ?.status === _orderStatus_.returned
                              ? 'badge bg-danger'
                              : 'badge bg-warning'
                          }
                        >
                          Item Status: &nbsp;{' '}
                          {orderDetailModalShow?.data?.orderItems?.status}
                        </Badge>
                      </div>
                      <div key={Math.floor(Math.random() * 100000)}>
                        <Row className='pt-3 w-100 m-auto'>
                          <Col md={8}>
                            <Row>
                              <Col md={3}>
                                <img
                                  className='h-75 w-100'
                                  src={`${process.env.REACT_APP_IMG_URL}${_productImg_}${orderDetailModalShow?.data?.orderItems?.productImage}`}
                                  alt={
                                    orderDetailModalShow?.data?.orderItems
                                      ?.productName
                                  }
                                />
                              </Col>
                              <Col md={9}>
                                {orderDetailModalShow?.data?.orderItems
                                  ?.productName && (
                                  <p className='mb-1'>
                                    {
                                      orderDetailModalShow?.data?.orderItems
                                        ?.productName
                                    }
                                  </p>
                                )}
                                <Table className='align-middle table-view'>
                                  <tbody>
                                    {orderDetailModalShow?.data?.orderItems
                                      ?.sellerName && (
                                      <tr className='pv-productd-remhover'>
                                        <th className='text-nowrap fw-normal'>
                                          Seller :
                                        </th>
                                        <td className='bold'>
                                          {
                                            orderDetailModalShow?.data
                                              ?.orderItems?.sellerName
                                          }
                                        </td>
                                      </tr>
                                    )}
                                    {orderDetailModalShow?.data?.orderItems
                                      ?.productSKUCode && (
                                      <tr className='pv-productd-remhover'>
                                        <th className='text-nowrap fw-normal'>
                                          SKU Code :{' '}
                                        </th>
                                        <td className='bold'>
                                          {
                                            orderDetailModalShow?.data
                                              ?.orderItems?.productSKUCode
                                          }
                                        </td>
                                      </tr>
                                    )}
                                    {orderDetailModalShow?.data?.orderItems
                                      ?.sizeValue && (
                                      <tr className='pv-productd-remhover'>
                                        <th className='text-nowrap fw-normal'>
                                          Size :
                                        </th>
                                        <td className='bold'>
                                          {
                                            orderDetailModalShow?.data
                                              ?.orderItems?.sizeValue
                                          }
                                        </td>
                                      </tr>
                                    )}
                                    <tr className='pv-productd-remhover'>
                                      <th className='text-nowrap fw-normal'>
                                        Color :
                                      </th>
                                      <td className='bold'>#fff</td>
                                    </tr>
                                    {orderDetailModalShow?.data?.orderItems
                                      ?.orderTaxInfos?.length > 0 && (
                                      <>
                                        <tr className='pv-productd-remhover'>
                                          <th className='text-nowrap fw-normal'>
                                            GST Rate :
                                          </th>
                                          <td className='bold'>
                                            {
                                              JSON.parse(
                                                orderDetailModalShow?.data
                                                  ?.orderItems?.orderTaxInfos[0]
                                                  ?.orderTaxRate
                                              )?.IGST
                                            }
                                            %
                                          </td>
                                        </tr>
                                        {orderDetailModalShow?.data?.orderItems
                                          ?.hsnCode && (
                                          <tr className='pv-productd-remhover'>
                                            <th className='text-nowrap fw-normal'>
                                              HSN Code :
                                            </th>
                                            <td className='bold'>
                                              {
                                                orderDetailModalShow?.data
                                                  ?.orderItems?.hsnCode
                                              }
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                              {/* <Col>
                                          <p className='mt-2'>
                                            IMEI No/ Series No :&nbsp;
                                            <Badge
                                              pill
                                              className='badge bg-danger'
                                            >
                                              IMEI No/ Series No. is Pending
                                            </Badge>
                                          </p>
                                        </Col> */}
                            </Row>
                          </Col>
                          <Col md={4}>
                            <Table className='align-middle table-view '>
                              <tbody>
                                <tr className='pv-productd-remhover'>
                                  <th className=' fw-normal'>
                                    Selling Price :
                                  </th>
                                  <td className='bold'>
                                    {
                                      orderDetailModalShow?.data?.orderItems
                                        ?.sellingPrice
                                    }
                                  </td>
                                </tr>
                                <tr className='pv-productd-remhover'>
                                  <th className=' fw-normal'>Qty : </th>
                                  <td className='bold'>
                                    {
                                      orderDetailModalShow?.data?.orderItems
                                        ?.qty
                                    }
                                  </td>
                                </tr>
                                <tr className='pv-productd-remhover'>
                                  <th className=' fw-normal'>
                                    Total Item Price :
                                  </th>
                                  <td className='bold'>
                                    {
                                      orderDetailModalShow?.data?.orderItems
                                        ?.totalAmount
                                    }
                                  </td>
                                </tr>
                                {orderDetailModalShow?.data?.orderItems
                                  ?.orderTaxInfos?.length > 0 && (
                                  <tr className='pv-productd-remhover'>
                                    <th className=' fw-normal'>
                                      Shipping Charges :
                                    </th>
                                    <td className='bold'>
                                      {orderDetailModalShow?.data?.orderItems
                                        ?.orderTaxInfos[0]?.shippingCharge ?? 0}
                                    </td>
                                  </tr>
                                )}
                                {orderDetailModalShow?.data?.orderItems
                                  ?.orderWiseExtraCharges?.length > 0 &&
                                  orderDetailModalShow?.data?.orderItems?.orderWiseExtraCharges?.map(
                                    (item) => (
                                      <tr className='pv-productd-remhover'>
                                        <th className=' fw-normal'>
                                          {item?.chargesType} :
                                        </th>
                                        <td className='bold'>
                                          {item?.chargesValueInAmount}
                                        </td>
                                      </tr>
                                    )
                                  )}

                                {/* <tr className='pv-productd-remhover'>
                                                  <th className=' fw-normal'>
                                                    Discount :
                                                  </th>
                                                  <td className='bold'>
                                                    {data?.discount}%
                                                  </td>
                                                </tr> */}
                                <tr className='pv-productd-remhover'>
                                  <th className=' fw-normal'>Total Amount :</th>
                                  <td className='bold'>
                                    {
                                      orderDetailModalShow?.data?.orderItems
                                        ?.subTotal
                                    }
                                  </td>
                                </tr>
                                <tr className='pv-productd-remhover'>
                                  <th className=' fw-normal'>
                                    Including GSt :
                                  </th>
                                  <td className='bold'>999</td>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                          <div className='d-flex justify-content-end gap-3 border-top pt-3'>
                            {/* Accept Request */}
                            {orderDetailModalShow?.data?.orderItems?.status ===
                              _orderStatus_.returnRequest && (
                              <Button
                                onClick={async () => {
                                  try {
                                    setLoading(true)
                                    const response = await axiosProvider({
                                      method: 'GET',
                                      endpoint: 'Seller/Order/Getwarehouse',
                                      queryString: `?sellerId=${orderDetailModalShow?.data?.orderItems?.sellerID}&sellerProductId=${orderDetailModalShow?.data?.orderItems?.sellerProductID}&productId=${orderDetailModalShow?.data?.orderItems?.productID}&sizeId=${orderDetailModalShow?.data?.orderItems?.sizeID}&quantity=${orderDetailModalShow?.data?.orderItems?.qty}`
                                    })
                                    setLoading(false)

                                    if (response?.status === 200) {
                                      if (response?.data?.data?.length > 0) {
                                        setModalShow({
                                          type: 'return-order',
                                          show: !modalShow?.show,
                                          data: response?.data?.data
                                        })
                                        // setInitialValues({
                                        //   ...initialValues,
                                        //   confirm: {
                                        //     ...initVal?.confirm,
                                        //     orderItemId:
                                        //       orderDetailModalShow?.data
                                        //         ?.orderItems?.id,
                                        //     orderId:
                                        //       orderDetailModalShow?.data
                                        //         ?.orderItems?.orderID
                                        //   }
                                        // })
                                      } else {
                                        Swal.fire({
                                          title: 'No Available Warehouses',
                                          text: `There are currently no warehouses available to fulfill ${orderDetailModalShow?.data?.orderItems?.productName}`,
                                          icon: 'info',
                                          confirmButtonText: 'OK'
                                        })
                                      }
                                    }
                                  } catch {
                                    setLoading(false)

                                    showToast(toast, setToast, {
                                      data: {
                                        message: _exception?.message,
                                        code: 204
                                      }
                                    })
                                  }
                                }}
                              >
                                Accept
                              </Button>
                            )}

                            {orderDetailModalShow?.data?.orderItems?.status ===
                              _orderStatus_.returnRequest && (
                              <Button
                                variant='secondary'
                                onClick={async () => {
                                  Swal.fire({
                                    title: 'Confirm Cancellation of Order Item',
                                    text: `Are you sure you want to cancel ${orderDetailModalShow?.data?.orderItems?.productName} in the order? This action cannot be undone.`,
                                    icon: _SwalDelete.icon,
                                    showCancelButton:
                                      _SwalDelete.showCancelButton,
                                    confirmButtonColor:
                                      _SwalDelete.confirmButtonColor,
                                    cancelButtonColor:
                                      _SwalDelete.cancelButtonColor,
                                    confirmButtonText: 'Yes, Cancel Item',
                                    cancelButtonText: 'No, Keep Item'
                                  }).then(async (result) => {
                                    if (result.isConfirmed) {
                                      try {
                                        setLoading(true)
                                        const data = {
                                          returnRequestId:
                                            orderDetailModalShow?.data?.id,
                                          orderItemID:
                                            orderDetailModalShow?.data
                                              ?.orderItemID,
                                          orderID:
                                            orderDetailModalShow?.data?.orderID,
                                          approvedByID: userInfo?.userId,
                                          approvedByName: userInfo?.userName,
                                          status: _orderStatus_?.returnRejected,
                                          refundStatus: '',
                                          dropContactPersonName: '',
                                          dropContactPersonMobileNo: '',
                                          dropContactPersonEmailID: '',
                                          dropCompanyName: '',
                                          dropAddressLine1: '',
                                          dropAddressLine2: '',
                                          dropLandmark: '',
                                          dropPincode: 0,
                                          dropCity: '',
                                          dropState: '',
                                          dropCountry: '',
                                          customeProductName: '',
                                          shipmentID: '',
                                          shipmentOrderID: '',
                                          shippingPartner: '',
                                          courierName: '',
                                          shippingAmountFromPartner: 0,
                                          awbNo: '',
                                          isShipmentSheduledByAdmin: true,
                                          pickupLocationID: '',
                                          errorMessage: '',
                                          forwardLable: '',
                                          returnLable: '',
                                          sellerID:
                                            orderDetailModalShow?.data
                                              ?.sellerID,
                                          warehouseId: 0,
                                          refundAmount: 0
                                        }

                                        const response = await axiosProvider({
                                          method: 'POST',
                                          endpoint:
                                            'ManageOrder/OrderReturnRequest',
                                          data,
                                          userId: userInfo?.userId,
                                          location: location.pathname
                                        })
                                        setLoading(false)
                                        if (response?.status === 200) {
                                          const order = await axiosProvider({
                                            method: 'GET',
                                            endpoint:
                                              'Admin/Order/GetOrderReturn',
                                            queryString: `?searchText=${encodedSearchText(filterDetails?.searchText)}&pageIndex=${filterDetails?.pageIndex}&pageSize=${filterDetails?.pageSize}`
                                          })

                                          if (order?.status === 200) {
                                            getOrderItems(
                                              data?.orderID,
                                              order?.data?.data
                                            )
                                          }
                                          showToast(toast, setToast, response)
                                        }
                                      } catch {
                                        setLoading(false)
                                        showToast(toast, setToast, {
                                          data: {
                                            message: _exception?.message,
                                            code: 204
                                          }
                                        })
                                      }
                                    }
                                  })
                                }}
                              >
                                Cancel
                              </Button>
                            )}

                            {orderDetailModalShow?.data?.orderItems?.status ===
                              _orderStatus_.replaceRequest && (
                              <Button
                                onClick={async () => {
                                  try {
                                    setLoading(true)
                                    const response = await axiosProvider({
                                      method: 'GET',
                                      endpoint: 'Seller/Order/Getwarehouse',
                                      queryString: `?sellerId=${orderDetailModalShow?.data?.orderItems?.sellerID}&sellerProductId=${orderDetailModalShow?.data?.orderItems?.sellerProductID}&productId=${orderDetailModalShow?.data?.orderItems?.productID}&sizeId=${orderDetailModalShow?.data?.orderItems?.sizeID}&quantity=${orderDetailModalShow?.data?.orderItems?.qty}`
                                    })
                                    setLoading(false)

                                    if (response?.status === 200) {
                                      if (response?.data?.data?.length > 0) {
                                        setModalShow({
                                          type: 'return-order',
                                          show: !modalShow?.show,
                                          data: response?.data?.data,
                                          isReplaceOrder: true
                                        })
                                      } else {
                                        Swal.fire({
                                          title: 'No Available Warehouses',
                                          text: `There are currently no warehouses available to fulfill ${orderDetailModalShow?.data?.orderItems?.productName}`,
                                          icon: 'info',
                                          confirmButtonText: 'OK'
                                        })
                                      }
                                    }
                                  } catch {
                                    setLoading(false)

                                    showToast(toast, setToast, {
                                      data: {
                                        message: _exception?.message,
                                        code: 204
                                      }
                                    })
                                  }
                                }}
                              >
                                Accept
                              </Button>
                            )}

                            {orderDetailModalShow?.data?.orderItems?.status ===
                              _orderStatus_.replaceRequest && (
                              <Button
                                variant='secondary'
                                onClick={async () => {
                                  Swal.fire({
                                    title: 'Confirm Cancellation of Order Item',
                                    text: `Are you sure you want to cancel ${orderDetailModalShow?.data?.orderItems?.productName} in the order? This action cannot be undone.`,
                                    icon: _SwalDelete.icon,
                                    showCancelButton:
                                      _SwalDelete.showCancelButton,
                                    confirmButtonColor:
                                      _SwalDelete.confirmButtonColor,
                                    cancelButtonColor:
                                      _SwalDelete.cancelButtonColor,
                                    confirmButtonText: 'Yes, Cancel Item',
                                    cancelButtonText: 'No, Keep Item'
                                  }).then(async (result) => {
                                    if (result.isConfirmed) {
                                      try {
                                        setLoading(true)
                                        const data = {
                                          returnRequestId:
                                            orderDetailModalShow?.data?.id,
                                          orderItemID:
                                            orderDetailModalShow?.data
                                              ?.orderItemID,
                                          orderID:
                                            orderDetailModalShow?.data?.orderID,
                                          approvedByID: userInfo?.userId,
                                          approvedByName: userInfo?.userName,
                                          status:
                                            _orderStatus_?.replaceRejected,
                                          refundStatus: '',
                                          dropContactPersonName: '',
                                          dropContactPersonMobileNo: '',
                                          dropContactPersonEmailID: '',
                                          dropCompanyName: '',
                                          dropAddressLine1: '',
                                          dropAddressLine2: '',
                                          dropLandmark: '',
                                          dropPincode: 0,
                                          dropCity: '',
                                          dropState: '',
                                          dropCountry: '',
                                          customeProductName: '',
                                          shipmentID: '',
                                          shipmentOrderID: '',
                                          shippingPartner: '',
                                          courierName: '',
                                          shippingAmountFromPartner: 0,
                                          awbNo: '',
                                          isShipmentSheduledByAdmin: true,
                                          pickupLocationID: '',
                                          errorMessage: '',
                                          forwardLable: '',
                                          returnLable: '',
                                          sellerID:
                                            orderDetailModalShow?.data
                                              ?.sellerID,
                                          warehouseId: 0,
                                          refundAmount: 0
                                        }

                                        const response = await axiosProvider({
                                          method: 'POST',
                                          endpoint:
                                            'ManageOrder/OrderReplaceRequest',
                                          data,
                                          userId: userInfo?.userId,
                                          location: location.pathname
                                        })
                                        setLoading(false)
                                        if (response?.status === 200) {
                                          const order = await axiosProvider({
                                            method: 'GET',
                                            endpoint:
                                              'Admin/Order/GetOrderReturn',
                                            queryString: `?searchText=${encodedSearchText(filterDetails?.searchText)}&pageIndex=${filterDetails?.pageIndex}&pageSize=${filterDetails?.pageSize}`
                                          })

                                          if (order?.status === 200) {
                                            getOrderItems(
                                              data?.orderID,
                                              order?.data?.data
                                            )
                                          }
                                          showToast(toast, setToast, response)
                                        }
                                      } catch {
                                        setLoading(false)
                                        showToast(toast, setToast, {
                                          data: {
                                            message: _exception?.message,
                                            code: 204
                                          }
                                        })
                                      }
                                    }
                                  })
                                }}
                              >
                                Cancel
                              </Button>
                            )}
                          </div>
                        </Row>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col md={4}>
              <div className='card p-3 mb-4'>
                <h3>Order Details</h3>
                <Table className='align-middle table-view '>
                  <tbody>
                    {orderDetailModalShow?.data?.deliveryDate && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>
                          Delivery Date :
                        </th>
                        <td className='bold'>
                          {moment(
                            orderDetailModalShow?.data?.deliveryDate
                          ).format('DD/MM/YYYY')}
                        </td>
                      </tr>
                    )}
                    {orderDetailModalShow?.data?.status && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>Status : </th>
                        <td className='bold'>
                          <Badge
                            className={
                              orderDetailModalShow?.data?.status ===
                              _orderStatus_.placed
                                ? 'badge bg-info'
                                : orderDetailModalShow?.data?.status ===
                                  _orderStatus_.delivered
                                ? 'badge bg-success'
                                : orderDetailModalShow?.data?.status ===
                                    _orderStatus_.cancelled ||
                                  orderDetailModalShow?.data?.status ===
                                    _orderStatus_.returned
                                ? 'badge bg-danger'
                                : 'badge bg-warning'
                            }
                          >
                            {orderDetailModalShow?.data?.status}
                          </Badge>
                        </td>
                      </tr>
                    )}
                    {orderDetailModalShow?.data?.coupon && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>Used Coupon :</th>
                        <td className='bold'>
                          {orderDetailModalShow?.data?.coupon}
                        </td>
                      </tr>
                    )}

                    {orderDetailModalShow?.data?.coupontDiscount !== null &&
                      orderDetailModalShow?.data?.coupontDiscount !==
                        undefined &&
                      orderDetailModalShow?.data?.coupontDiscount !== '' && (
                        <tr className='pv-productd-remhover'>
                          <th className='text-nowrap fw-normal'>Discount :</th>
                          <td className='bold'>
                            {orderDetailModalShow?.data?.coupontDiscount}
                          </td>
                        </tr>
                      )}
                    {orderDetailModalShow?.data?.paidAmount !== null &&
                      orderDetailModalShow?.data?.paidAmount !== undefined &&
                      orderDetailModalShow?.data?.paidAmount !== '' && (
                        <tr className='pv-productd-remhover'>
                          <th className='text-nowrap fw-normal'>
                            Amount Paid :
                          </th>
                          <td className='bold'>
                            {orderDetailModalShow?.data?.paidAmount}
                          </td>
                        </tr>
                      )}
                    {orderDetailModalShow?.data?.paymentMode && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>
                          Payment Mode :
                        </th>
                        <td className='bold text-uppercase'>
                          <Badge
                            className={
                              orderDetailModalShow?.data?.paymentMode === 'cod'
                                ? 'badge bg-danger'
                                : 'badge bg-success'
                            }
                          >
                            {orderDetailModalShow?.data?.paymentMode}
                          </Badge>
                        </td>
                      </tr>
                    )}
                    {orderDetailModalShow?.data?.status && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>Shipment By :</th>
                        <td className='bold'>999</td>
                      </tr>
                    )}
                    {orderDetailModalShow?.data?.orderBy && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>Order By :</th>
                        <td className='bold text-capitalize'>
                          <Badge className={'badge bg-info'}>
                            {orderDetailModalShow?.data?.orderBy}
                          </Badge>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              <div className='card p-3 mt-3'>
                <h3>Customer Details</h3>
                <Table className='align-middle table-view '>
                  <tbody>
                    {orderDetailModalShow?.data?.userName && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>Name :</th>
                        <td className='bold'>
                          {orderDetailModalShow?.data?.userName}
                        </td>
                      </tr>
                    )}
                    {orderDetailModalShow?.data?.userPhoneNo && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>Mobile : </th>
                        <td className='bold'>
                          {orderDetailModalShow?.data?.userPhoneNo}
                        </td>
                      </tr>
                    )}
                    {orderDetailModalShow?.data?.userEmail && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>Email :</th>
                        <td className='bold'>
                          {orderDetailModalShow?.data?.userEmail}
                        </td>
                      </tr>
                    )}
                    {orderDetailModalShow?.data?.userAddressLine1 && (
                      <tr className='pv-productd-remhover'>
                        <th className='text-nowrap fw-normal'>Address :</th>
                        <td className='bold'>
                          {orderDetailModalShow?.data?.userAddressLine1 && (
                            <>
                              {orderDetailModalShow?.data.userAddressLine1}
                              <br />
                            </>
                          )}
                          {orderDetailModalShow?.data?.userAddressLine2 && (
                            <>
                              {orderDetailModalShow?.data.userAddressLine2}
                              <br />
                            </>
                          )}
                          {orderDetailModalShow?.data?.userLandmark && (
                            <>
                              {orderDetailModalShow?.data.userLandmark}
                              <br />
                            </>
                          )}
                          {orderDetailModalShow?.data?.userCity && (
                            <>
                              {orderDetailModalShow?.data.userCity}
                              <br />
                            </>
                          )}
                          {orderDetailModalShow?.data?.userPincode && (
                            <>
                              {orderDetailModalShow?.data.userPincode}
                              <br />
                            </>
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>

            {/* <Col md={12}>
              <div className='d-flex justify-content-end gap-4'>
                {values?.orderItemIDs?.length > 0 && (
                  <>
                    <Button
                      onClick={() => {
                        let packageAmount =
                          orderDetailModalShow?.data?.orderItems
                            ?.filter((item) =>
                              values?.orderItemIDs?.includes(item.id)
                            )
                            ?.reduce((acc, curr) => acc + curr.subTotal, 0)
                        let packageData = {
                          orderID: orderDetailModalShow?.data?.orderId,
                          orderItemIDs: values?.orderItemIDs?.join(','),
                          totalItems: values?.orderItemIDs?.length,
                          packageAmount
                        }
                        setInitialValues({
                          ...initialValues,
                          pack: {
                            ...initialValues?.pack,
                            ...packageData
                          }
                        })
                        setModalShow({
                          type: 'package',
                          show: !modalShow.show
                        })
                      }}
                    >
                      Pack order
                    </Button>
                    <Button
                      onClick={() => {
                        setFieldValue('orderItemIDs', [])
                      }}
                    >
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Col> */}
          </Row>
          {/* </Form>
            )}
          </Formik> */}
        </Offcanvas.Body>
      </Offcanvas>

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {modalShow?.show && modalShow?.type === 'return-order' && (
        <ConfirmReturnRequest
          modalShow={modalShow}
          setModalShow={setModalShow}
          getOrderItems={getOrderItems}
          setLoading={setLoading}
          orderDetailModalShow={orderDetailModalShow}
          setToast={setToast}
          toast={toast}
          filterDetails={filterDetails}
        />
      )}
    </>
  )
}

export default ReturnOrderDetail
